import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { INote, INoteBody, INoteResponse } from 'src/app/models/dashboard.models';
import { NoteService } from 'src/app/services/note.service';
declare var $: any;

@Component({
  selector: 'app-create-note',
  templateUrl: './create-note.component.html',
  styleUrls: ['./create-note.component.scss']
})
export class CreateNoteComponent implements OnInit {

  title: string = 'Create note';
  noteTitle: string = '';
  noteText: string = '';
  @Output() note = new EventEmitter();
  noteId: number;
  saveBtn: boolean = false;

  constructor(public noteService: NoteService) { }

  ngOnInit(): void {
  }

  createOrUpdateNote(){
    this.saveBtn = true;
    if(this.noteId)
    {
      let body: INoteBody={
        noteId: this.noteId,
        noteTitle : this.noteTitle,
        noteText : this.noteText
      }
  
      this.noteService.updateNote(body)
      .subscribe((res: INoteResponse)=>{
        console.log("Note Updated: ",res);
        this.saveBtn = false;
        $('#create-note').modal('hide');
        this.clearData();
        this.note.emit(res.payload);
      },err=>{
        this.saveBtn = false; 
        console.error(err);
      });
    }
    else{
      let body: INoteBody={
        noteTitle : this.noteTitle,
        noteText : this.noteText
      }
  
      this.noteService.createNote(body)
      .subscribe((res: INoteResponse)=>{
        console.log("Note Created: ",res);
        this.saveBtn = false;
        $('#create-note').modal('hide');
        this.clearData();
        this.note.emit(res.payload);
      },err=>{
        this.saveBtn = false; 
        console.error(err);
      });
    }
  }

  editNote(note: INote){
    this.title = 'Edit Note';
    this.noteId = note.noteId;
    this.noteTitle = note.noteTitle;
    this.noteText = note.noteText;
  }

  clearData(){
    this.title = 'Create Note';
    this.noteTitle = '';
    this.noteText = '';
  }

}
